module.exports = __webpack_public_path__ + "static/media/iconM5.2bd8c802.svg";